var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 800,
    viewBox: "0 0 510 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.839 659H194.162C188.136 658.921 182.379 656.494 178.117 652.233C173.856 647.973 171.427 642.216 171.348 636.191V400.5L8.60468 178.19C6.03243 174.847 4.46614 170.84 4.08894 166.639C3.71174 162.438 4.53945 158.216 6.47533 154.469C8.41456 150.732 11.3376 147.595 14.9295 145.398C18.5214 143.2 22.6453 142.026 26.8562 142H483.145C487.355 142.026 491.48 143.2 495.073 145.398C498.662 147.595 501.585 150.732 503.526 154.469C505.461 158.216 506.288 162.438 505.911 166.639C505.534 170.84 503.97 174.847 501.397 178.19L338.654 400.5V636.191C338.575 642.216 336.147 647.973 331.885 652.233C327.624 656.494 321.865 658.921 315.839 659ZM216.977 613.382H293.025V392.897C293 388.052 294.607 383.339 297.588 379.516L437.516 187.618H72.4851L213.022 379.516C216.003 383.339 217.609 388.052 217.585 392.897L216.977 613.382Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFilter);
export default __webpack_public_path__ + "static/media/ico_filter.a4d58c28fd84a564eafb995f8e616114.svg";
export { ForwardRef as ReactComponent };